import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./imageslider.css"


const ImageCarousel = (props) => {
    let { images, sliderOnclick } = props;
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
        arrows: true,
        dots: true,
    };



    function returnFlag(extType) {
        let returntxt = ""
        switch (extType) {
            case "video":
                returntxt = <div className="ribbon ribbon-top-left"><span>Video</span></div>
                break;
            default:
                break;
        }
        return returntxt
    }

    return <div className="slider-container">
        <Slider {...settings}>
            {
                images.map((item, index) => {
                    let { file, extType, uniqueId } = item
                    return <div key={index} className="slide" onClick={() => {
                        sliderOnclick(uniqueId)
                    }}>
                        <div key={index} className="slideInner mo-slideInner">
                            <div className="position-relative" >
                                <img className="img-fluid" src={file} alt="" />
                                {returnFlag(extType)}
                            </div>
                        </div>
                    </div>
                })
            }
        </Slider>

    </div>
};

export default ImageCarousel;
